



































import { Component, Prop } from 'vue-property-decorator';
import DescriptionBar from './DescriptionBar.vue';
import ScoreInputBase from './ScoreInputBase';

@Component({ components: { DescriptionBar } })
export default class Emoticons extends ScoreInputBase {
  /**
   * Usado para distinguir quais emoticons usar
   */
  @Prop({ default: 'nps' })
  public indicator: string;

  public accessibleName(score: number): string {
    const option = this.$t('generic.scoreOption', { score }) as string;
    return this.accessibleLabel ? `${this.accessibleLabel}: ${option}` : option;
  }
}
